














































































import { Component, Mixins } from "vue-property-decorator";
import vClickOutside from 'v-click-outside'
import { namespace } from "vuex-class";
import userApi from "@/api/userApi";
import store from "@/store";
import updateClassSidebar from "@/mixin/updateClassSidebar.ts";
const auth = namespace("Auth");

@Component({
  name: "QSiderbar",
  directives: {
    clickOutside: vClickOutside.directive,
  }
})
export default class QSiderbar extends Mixins(updateClassSidebar) {
  @auth.Getter
  getUserType!: (token: string) => void;

  public classPage = ["mb__admin-navbox"];

  public created() {
    this.classPage = this.changeClassPage(this.classPage);
  }

  public async logout() {
    try {
      const result = await userApi.logout();
      if (result.status === 200) {
        store.dispatch("Auth/logout");
      }
    } catch (error) {
      console.log(error);
    }
  }

  toggleMenu(isOpen) {
    const changeClass = this.classPage;
    if (isOpen) {
      changeClass.push("open");
    } else {
      changeClass.pop();
    }
    this.classPage = changeClass;
  }

  public closeMenu(event) {
    this.$emit('closeMenu', event)
  }
}
